module.exports = __webpack_public_path__ + "static/media/serbia.f2ac985b.svg";